import {
  usePromptVersions,
  type PromptResource,
  type PromptVersion,
  type PromptVersionSummary,
  type PromptVersionsResponse,
  type PromptVersionsState,
} from './usePromptVersions'

export type { PromptVersion, PromptVersionSummary }

export type AgentName = 'david' | 'hanna'

interface AgentPromptResponse extends PromptVersionsResponse {
  agent: AgentName
}

export type AgentPromptState = PromptVersionsState<AgentPromptResponse>

const AGENT_PROMPT: PromptResource = {
  path: 'admin/agent-prompt',
  routes: 'agent-prompt',
  queryKey: 'agent-prompt',
  noun: 'prompt',
}

/**
 * Serves an agent's system prompt and everything it has been.
 *
 * Pass `enabled: false` to hold the read until the caller needs it.
 */
export function useAgentPrompt(
  agent: AgentName,
  enabled: boolean = true
): AgentPromptState {
  return usePromptVersions<AgentPromptResponse>(AGENT_PROMPT, agent, enabled)
}
